import { ProductStockDTO } from './ProductStockDTO';

// FIXME: reuse type defined in domains/common/src/server/lib/delivery/ProductDeliveryInfoValue.ts
export enum StockStatus {
    IN_STOCK = 'IN_STOCK',
    OUT_OF_STOCK = 'OUT_OF_STOCK',
}

export type ProductStockType = Readonly<{
    warehouse: {
        status: StockStatus;
        deliveryMessage?: string;
    };
    store: {
        status: StockStatus;
        deliveryMessage?: string;
    };
}>;

export const isProductAvailable = (stock: ProductStockDTO | undefined): boolean =>
    !!stock &&
    !(stock.warehouse.status === StockStatus.OUT_OF_STOCK && stock.store.status === StockStatus.OUT_OF_STOCK);
